/**
 * When the board may move focus on the person's behalf (verification round 2, 2026-10-14).
 *
 * After an act opens, the kit (and a workspace's own act target, e.g. UMED's caseAnchor) moves focus into the dock --
 * but only while focus is still where the act left it: the page body, the element that was focused when the act
 * started, the card's drag grip or Move button (or a Move item), or the dock's own heading. Once the person has gone
 * somewhere else -- the search box, another card, a field in the dock -- nothing takes focus back.
 *
 * And never onto a control that commits: an act's focus target is its heading or its explanatory text, so a key
 * repeat or a second Space after a keyboard drop cannot press "Approve".
 */
export const BOARD_FOCUS_SPOTS = '.okb-card__grip, .okb-move__btn, .okb-move__item, .board-dock__title';

export function mayTakeFocus(active: Element | null | undefined, origin?: Element | null): boolean {
  if (typeof document === 'undefined') return false;
  if (!active || active === document.body || active === document.documentElement) return true;
  if (origin && active === origin) return true;
  return typeof (active as HTMLElement).matches === 'function' && (active as HTMLElement).matches(BOARD_FOCUS_SPOTS);
}

/** A focus target an act may land on: never a button, a link, a submit or any other control a key would activate. */
export function isCommitControl(el: Element | null | undefined): boolean {
  if (!el) return false;
  if (/^(BUTTON|A|INPUT|SELECT|TEXTAREA|SUMMARY)$/.test(el.tagName)) return true;
  const role = el.getAttribute('role');
  return role === 'button' || role === 'link' || role === 'menuitem' || role === 'checkbox' || role === 'switch';
}
